import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { approveWithdrawRequest } from '../withdrawRequestsEndpoints'
import { withdrawRequestKeys } from '../withdrawRequestsQueryKeys'
import type { ApproveWithdrawRequestInput } from '../../types/withdrawRequestsTypes'

export function useApproveWithdrawRequestMutation() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (input: ApproveWithdrawRequestInput) => approveWithdrawRequest(input),
    onSuccess: (_, vars) => {
      qc.invalidateQueries({ queryKey: withdrawRequestKeys.lists() })
      qc.invalidateQueries({ queryKey: withdrawRequestKeys.statusCounts() })
      qc.invalidateQueries({ queryKey: withdrawRequestKeys.detail(vars.id) })
    },
  })
}
